import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { API_GET, DBRequest, useConfig } from '../../api/api';
import ExoTable from '../exo/ExoTable';
import { useTranslation } from 'react-i18next';
import MoneyLabel from '../label/MoneyLabel';
import ExoTableRecipient from '../exo/ExoTableRecipient';
import DBSearch from '../special/DBSearch';
import ExoProcessing from '../exo/ExoProcessing';

const SelectOrder = ({
  apiUrl,
  onSelect,
  filter = '',
  selected,
  totalAmount,
  removeDrafts,
  useSearch = false,
}) => {
  const { t } = useTranslation();

  // API mode state
  const [apiData, setApiData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [isProcessing, setIsProcessing] = useState(false);
  const config = useConfig();
  useEffect(() => {
    if (useSearch || !config) return;
    DBRequest({
      config,
      path: apiUrl || `orders?${filter}`,
      method: API_GET,
      onResponse: handleApiResponse,
      onLoading: setIsLoading,
    });
  }, [config]);

  function handleApiResponse(data) {
    let newData = data;
    if (removeDrafts) {
      newData.data = newData?.data.filter((el) => Boolean(el.nr));
    }
    setApiData(newData);
  }

  // Search mode state
  const [searchResults, setSearchResults] = useState(null);

  function handleSearch(hits) {
    setSearchResults({ data: hits });
  }

  function handleSearchResultSelect(row) {
    if (useSearch) {
      DBRequest({
        config,
        path: `orders/${row.id}`,
        onResponse: (res) => {
          onSelect(res.data);
        },
        onLoading: setIsProcessing,
      });
    } else {
      onSelect(row);
    }
  }

  //tabel
  const Columns = [
    {
      header: t('Ordner Nr'), // header of column
      key: 'nr', // key of column in row-object
      thAlign: 'left', // header text alignment
      tdAlign: 'left', // cell text alignment
      sortable: !useSearch, // enable sort function for column
      cell: ({ row }) => (
        <Box className="monospace whitespace-nowrap">
          {(row.nr || row.formattedNr) ?? t('Draft')}
        </Box>
      ), // custom xml for cells in the column. you get the row as object
      onClick: (row) => handleSearchResultSelect(row),
    },
    {
      header: t('Title'), // header of column
      key: 'title', // key of column in row-object
      thAlign: 'left', // header text alignment
      tdAlign: 'left', // cell text alignment
      sortable: true, // enable sort function for column
      width: '100%', // width of column
      onClick: (row) => handleSearchResultSelect(row),
    },
    {
      header: t('Recipient'),
      key: 'recipient',
      thAlign: 'left', // header text alignment
      tdAlign: 'left', // cell text alignment
      width: '270px',
      sortable: true, // enable sort function for column
      hiddenMobile: true,
      cell: ({ row }) => <ExoTableRecipient row={row} />, // custom xml for cells in the column. you get the row as object
      onClick: (row) => handleSearchResultSelect(row),
    },
    {
      header: t('Netto'), // header of column
      key: 'netto', // key of column in row-object
      thAlign: 'right', // header text alignment
      tdAlign: 'right', // cell text alignment
      sortable: true, // enable sort function for column
      width: '200px', // width of column
      cell: ({ row }) => (
        <MoneyLabel
          money={
            useSearch
              ? row.netto_sum
              : totalAmount
                ? row.volume
                : row.openVolume
          }
        />
      ), // custom xml for cells in the column. you get the row as object
      onClick: (row) => handleSearchResultSelect(row),
    },
    /*{
      header: t('Open'), // header of column
      key: 'openVolume', // key of column in row-object
      thAlign: 'right', // header text alignment
      tdAlign: 'right', // cell text alignment
      sortable: true, // enable sort function for column
      width: '200px', // width of column
      cell: ({ row }) => (
        <MoneyLabel money={totalAmount ? row.volume : row.openVolume} />
      ), // custom xml for cells in the column. you get the row as object
      onClick: (row) => onSelect(row),
    },*/
  ];

  if (!useSearch) {
    return (
      <Box className="h-full">
        <ExoTable
          isSelectedElement={(row) => selected && row.id === selected.id}
          data={apiData}
          isLoading={isLoading}
          columns={Columns}
          noBackground
        />
      </Box>
    );
  }

  return (
    <>
      <DBSearch param={'orders'} onSearch={handleSearch} filter={filter}>
        <ExoTable
          isSelectedElement={(row) => selected && row.id === selected.id}
          data={searchResults}
          isLoading={!searchResults}
          columns={Columns}
          noBackground
        />
      </DBSearch>
      <ExoProcessing open={isProcessing} label={t('Loading Order')} />
    </>
  );
};

export default SelectOrder;
